import fallback_ca from './ca/fallback.json';
import fallback_es from './es/fallback.json';
import fallback_en from './en/fallback.json';
import custom_ca from '../overrides/i18n/ca.json';
import custom_es from '../overrides/i18n/es.json';
import custom_en from '../overrides/i18n/en.json';
import { getUrlParams } from "../utils/misc";
import { decodeJwt } from 'jose'
import store from "../store";
import { default as cookiesUtils } from '../utils/cookies';
import Settings from "../settings";
import _ from 'lodash';

const PARTNER_LANGUAGES = [
  { localeCode: "ca-ES", langCode: "ca", suffix: "ES", displayName: "Català", displayShort: "CAT" },
  { localeCode: "es-ES", langCode: "es", suffix: "ES", displayName: "Español", displayShort: "ES" },
  { localeCode: "en-US", langCode: "en", suffix: "US", displayName: "English", displayShort: "EN" },
  { localeCode: "gl-ES", langCode: "gl", suffix: "ES", displayName: "Galego", displayShort: "GL" },
  { localeCode: "fr-FR", langCode: "fr", suffix: "FR", displayName: "Français", displayShort: "FR" },
  { localeCode: "de-DE", langCode: "de", suffix: "DE", displayName: "Deutsch", displayShort: "DE" },
];

export const SUPPORTED_LANGS = ["ca-ES", "es-ES", "en-US"]

const updateTranslationsWithCustom = () => {
  _.merge(fallback_ca, custom_ca);
  _.merge(fallback_es, custom_es);
  _.merge(fallback_en, custom_en);
}

updateTranslationsWithCustom();

export const fallbackResources = {
  'ca-ES': {
    fallback: fallback_ca,
  },
  'es-ES': {
    fallback: fallback_es,
  },
  'en-US': {
    fallback: fallback_en,
  },
};


export const getVerifiedLanguage = (lang, separationChar="-") => {
  const availableLangs = getAvailablePartnerLangs();
  const LANG_SUFFIX = availableLangs.reduce((acc, { langCode, suffix }) => {
    acc[langCode] = suffix;
    return acc;
  }, {});
  let proccessedLang = null;

  if (!lang) { // INFO: Set a default that will not pass the sufix validation
    lang = "";
  }

  const prefix = lang.substring(0,2);
  const sufix = LANG_SUFFIX[prefix];
  if (sufix) { // INFO: If no suffix found mean the lang is malformatted or unexistent language
    proccessedLang = `${prefix}${separationChar}${sufix}`;
  } else if (lang !== Settings.language.default) {
    // INFO: Try again with the default language
    proccessedLang = getVerifiedLanguage(Settings.language.default);
  }
  else {
    // INFO: If the default lang is not well formatted returns the hardcoded one
    proccessedLang = `ca${separationChar}ES`;
    console.error(`WARNING: the default language from setting is malformatted (value: ${Settings.language.default}), setting ${proccessedLang}`);
  }



  return proccessedLang
}

export const getLangCode = (locale) => {
  let lang = "";
  if (locale) {
    lang = locale.indexOf('_') > 0 ? locale.replace('_', '-')
      : locale.indexOf('-') > 0 ? locale
      : Settings.language.partner[0] //buscar-lo a la llista dels que tenim
  }

  return getVerifiedLanguage(lang);
}

export const getLangByToken = (token) => {
  if (!token)
    return null;
  try {
    const token_values = decodeJwt(token);
    return token_values.locale;
  } catch (e) {
    console.debug('ERROR', e);
    return null;
  }
}

const getLangByUrlParam = () => {
  try {
    const urlParams = getUrlParams();
    return (urlParams && urlParams.lang && getLangCode(urlParams.lang)) || null;
  } catch (e) {
    console.debug('ERROR', e);
    return null;
  }
};

const getLangByCookies = () => {
  let lang = cookiesUtils.getLang();
  if (typeof lang === 'string') {
    return getVerifiedLanguage(lang);
  }
  return null;
};

export const getLangByBrowser = () => {
  try {
    return navigator.language;
  } catch (e) {
    console.debug('ERROR getting browser language');
    return null;
  }
}

export const getLang = () => {
  // First try to get the lang from url params
  let lang = getLangByUrlParam();

  // Second try to get the lang by cookies
  if (lang === null) {
    lang = getLangByCookies();
  }

  // Third try to get the lang from auth/token
  if (lang === null) {
    const auth = store.getState().auth;
    const token = (store.getState().auth === undefined) ? null : store.getState().auth.token;

    if (auth && token) {
      lang = getLangByToken(token);
    }
  }

  // Fourth try to get the lang from the browser
  if (lang === null) {
    lang = getLangByBrowser();
  }

  // Get the correct localeCode, if it is for example "en" -> "en-US"
  lang = getVerifiedLanguage(lang);

  cookiesUtils.saveLang(lang);
  return lang;
}

export const getAvailablePartnerLangs = () => {
  const enabledLangs = Settings?.language?.partner ?? [];
  return PARTNER_LANGUAGES.filter((partnerLang) => {
    const isAvailable = enabledLangs.find((availableLanguage) => {
      return availableLanguage.includes(partnerLang.langCode);
    });
    return isAvailable
  });
};

export const getAvailableResources = () => {
  let langs = getAvailablePartnerLangs();
  // langs = langs.map(lang => lang.localeCode.split('_')[0].toLowerCase());
  return langs;
};
